package com.shadowings.gero.data.lessons.chapter15

import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.abydos_name_ab24
import gero.composeapp.generated.resources.exp_content_nomi_nomi_nomi_1
import gero.composeapp.generated.resources.exp_content_nomi_nomi_nomi_2
import gero.composeapp.generated.resources.exp_content_nomi_nomi_nomi_3
import gero.composeapp.generated.resources.exp_content_nomi_nomi_nomi_4
import gero.composeapp.generated.resources.exp_content_nomi_nomi_nomi_5
import gero.composeapp.generated.resources.exp_content_nomi_nomi_nomi_6
import gero.composeapp.generated.resources.exp_title_nomi_nomi_nomi
import gero.composeapp.generated.resources.inscription_name_ri00200
import kotlin.random.Random

fun getNomiNomiNomiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_nomi_nomi_nomi,
            content = Res.string.exp_content_nomi_nomi_nomi_1,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_nomi_nomi,
            content = Res.string.exp_content_nomi_nomi_nomi_2,
            face = Faces.Doubt,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_nomi_nomi,
            content = Res.string.exp_content_nomi_nomi_nomi_3,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_nomi_nomi,
            content = Res.string.exp_content_nomi_nomi_nomi_4,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_nomi_nomi,
            content = Res.string.exp_content_nomi_nomi_nomi_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_nomi_nomi,
            content = Res.string.exp_content_nomi_nomi_nomi_6,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

// Cartouche photos from museum objects: image code (see InscriptionImages), words.tsv id
// (source of the reading), name with its meaning. MENKAURE reuses the existing word: the photo
// shows a different spelling (its variante1), but the reading is the same.
private val nomiNomiNomiNames = listOf(
    Triple("ri00182", "MENKAURE", Res.string.abydos_name_ab24),
    Triple("ri00200", "INTEF", Res.string.inscription_name_ri00200),
)

// Same as nomiImportantiQuizWordIds: quiz-only names the Compendio unlocks on lesson completion.
val nomiNomiNomiQuizWordIds: Set<String> = nomiNomiNomiNames.map { it.second }.toSet()

fun getNomiNomiNomiImageQuizContent(words: List<Word>): List<IQuizContent> =
    nomiNomiNomiNames.shuffled().mapNotNull { (imageCode, wordId, name) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = name
        )
    }

// The previous lesson's quiz minus 2 random questions + the 2 new cartouche photos.
fun getNomiNomiNomiQuizContent(
    hiero: List<Hiero>,
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String,
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    val previous = getTraduciamoINomiQuizContent(
        hiero = hiero,
        words = words,
        verbs = verbs,
        languageCode = languageCode,
        verbSentences = verbSentences,
        random = random
    ).shuffled(random).take(8)

    return previous + getNomiNomiNomiImageQuizContent(words)
}
